import { render, staticRenderFns } from "./categorymusic.vue?vue&type=template&id=e86004c4&"
import script from "./categorymusic.vue?vue&type=script&lang=js&"
export * from "./categorymusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports